export default __webpack_public_path__ + "static/media/danish.ad46db09.jpg";